// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#page_error[data-v-061f4ae1]{align-items:center;background:linear-gradient(135deg,#f5f7fa,#c3cfe2);display:flex;justify-content:center}#page_error[data-v-061f4ae1],#page_error.isPC[data-v-061f4ae1]{min-height:100vh}#page_error .v-container[data-v-061f4ae1]{align-items:center;display:flex;justify-content:center;min-height:100%}#page_error .v-card[data-v-061f4ae1]{-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);background:hsla(0,0%,100%,.95)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
